// Stripe Checkout refuses to render inside an iframe (X-Frame-Options).
// Browsers also silently *ignore* cross-origin `window.top.location.href`
// assignments without throwing, so we explicitly probe for same-origin
// access first and fall back to opening a new tab when we can't reach the
// top frame. This way the buyer always lands on Stripe regardless of
// whether the app is embedded in a preview/iframe.
export function redirectToStripe(url) {
  if (typeof window === "undefined") return;

  const inIframe = (() => {
    try { return window.top && window.top !== window.self; } catch { return true; }
  })();

  if (inIframe) {
    let canReachTop = false;
    try {
      // Touching `window.top.location.href` throws on cross-origin parents.
      // We only need to read a property to detect that.
      void window.top.location.href;
      canReachTop = true;
    } catch {
      canReachTop = false;
    }

    if (canReachTop) {
      window.top.location.href = url;
      return;
    }
    // Cross-origin iframe — `window.top.location.href = …` would be a
    // silent no-op. Open a new tab instead (requires this call to run
    // synchronously inside the click handler so popup blockers allow it).
    const opened = window.open(url, "_blank", "noopener,noreferrer");
    if (opened) return;
    // Popup blocked → last resort: replace this frame.
    window.location.href = url;
    return;
  }

  window.location.href = url;
}
